/**
 * Shown when saving a skill. Kept word for word with the reuse notes in
 * packages/encamp-scout/skills/create-skill.skill.md, which Scout shows when
 * it confirms a skill.
 */
export const SKILL_REUSE_NOTES = {
  staff:
    "Other Encamp staff may use this skill for other customers and facilities. Leave out details specific to one customer or site unless the skill is meant for them.",
  customer:
    "This skill may be used for your other facilities. Leave out details specific to one site unless the skill is meant for it.",
} as const;

export function skillReuseNote(isStaff: boolean): string {
  return isStaff ? SKILL_REUSE_NOTES.staff : SKILL_REUSE_NOTES.customer;
}
